module.exports = __webpack_public_path__ + "static/media/YF79_2.7dec9429.jpg";